import { useSelector } from "react-redux"
// Pages
import Home from "./pages/Home/Home"
import UserList from "./pages/UserList/UserList"
import User from "./pages/User/User"
import NewUser from "./pages/NewUser/NewUser"
import ProductList from "./pages/ProductList/ProductList"
import Product from "./pages/Product/Product"
import NewProduct from "./pages/NewProduct/NewProduct"
import Login from "./pages/Login/Login"
import OrderList from "./pages/OrderList/OrderList"
import Order from "./pages/Order/Order"
import FavoriteList from "./pages/FavoriteList/FavoriteList"
import NewShop from "./pages/NewShop/NewShop"
import Shop from "./pages/Shop/Shop"
import ShopList from "./pages/ShopList/ShopList"
import NewPageContent from "./pages/NewPageContent/NewPageContent"
import PageContent from "./pages/PageContent/PageContent"
import PageContentList from "./pages/PageContentList/PageContentList"
import NewImage from "./pages/NewImage/NewImage"
import Image from "./pages/Image/Image"
import ImageList from "./pages/ImageList/ImageList"
import EmailList from "./pages/EmailList/EmailList"
import ServiceRequest from "./pages/ServiceRequest/ServiceRequest"
import ServiceRequestList from "./pages/ServiceRequestList/ServiceRequestList"
import NewServiceRequest from "./pages/NewServiceRequest/NewServiceRequest"
// Routes
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import ScrollToTop from "./helpers/ScrollToTop"
// Styles
import { GlobalStyle } from "./GlobalStyle"
import { Theme } from "./Theme"
import { MuiThemeProvider } from "@material-ui/core"

const App = () => {
   const user = useSelector((state) => state.user.currentUser)
   const admin = user?.isAdmin

   return (
      <Router>
         <ScrollToTop />
         <MuiThemeProvider theme={Theme}>
            {admin ? (
               <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/users" element={<UserList />} />
                  <Route path="/user/:userId" element={<User />} />
                  <Route path="/newUser" element={<NewUser />} />
                  <Route path="/products" element={<ProductList />} />
                  <Route path="/product/:productId" element={<Product />} />
                  <Route path="/newProduct" element={<NewProduct />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/orders" element={<OrderList />} />
                  <Route path="/order/:orderId" element={<Order />} />
                  <Route path="/favorites" element={<FavoriteList />} />
                  <Route path="/newShop" element={<NewShop />} />
                  <Route path="/shop/:shopId" element={<Shop />} />
                  <Route path="/shops" element={<ShopList />} />
                  <Route path="/newPageContent" element={<NewPageContent />} />
                  <Route
                     path="/pageContent/:pageContentId"
                     element={<PageContent />}
                  />
                  <Route path="/page-contents" element={<PageContentList />} />
                  <Route path="/newImage" element={<NewImage />} />
                  <Route path="/image/:imageId" element={<Image />} />
                  <Route path="/images" element={<ImageList />} />
                  <Route path="/emails" element={<EmailList />} />
                  <Route path="/services" element={<ServiceRequestList />} />
                  <Route path="/newService" element={<NewServiceRequest />} />
                  <Route
                     path="/service/:requestId"
                     element={<ServiceRequest />}
                  />
               </Routes>
            ) : (
               <Routes>
                  <Route path="/*" element={<Login />} />
               </Routes>
            )}
            <GlobalStyle />
         </MuiThemeProvider>
      </Router>
   )
}

export default App
